const getName = (name = '') => {
  var separateWord = name && name.toLowerCase().split(' ');
  for (var i = 0; i < separateWord.length; i++) {
     separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
     separateWord[i].substring(1);
  }
  return separateWord ? separateWord.join(' ') : '';

  };
  
  export default getName;
  